export default __webpack_public_path__ + "45205c576f85f6c05a96e1e83552fd1e.png";